import ServiceMember from '@/js/store/calculator/state/ServiceMember';
import { getHi3PastYears } from '../utilities/hi3CareerProgressionHelpers';

class Hi3ServiceMember extends ServiceMember {
  constructor(formData, globalSettings, payTables, moduleSettings) {
    super(formData, globalSettings, payTables, moduleSettings);

    if (formData && globalSettings) {
      this.careerProgression.hi3PastYears = getHi3PastYears(this);
    }
  }
}

export default Hi3ServiceMember;
